
    var riot = require('riot')
     
riot.tag2('interpreter-booking', '<h2>Interpreter Booking Form</h2> <hr> <div hide="{loggedin}" class="alert alert-info"> <p>If you have an account, please login above before completing this form.</p> </div> <form onsubmit="{save}" class="form-horizontal"> <forminput label="Booking For" name="name" value="{booking.name}" onupdate="{handleUpdate}" isrequired placeholder="Name"></forminput> <div class="form-group"> <div class="col-sm-8 col-sm-offset-4"> <label> <input type="radio" name="booktype" __checked="{booking.meta.booktype==\'\'}" onclick="{handleMetaUpdate.bind(this,{name:\'booktype\',value:\'\'})}">General Booking </label><br> <label> <input type="radio" name="booktype" __checked="{booking.meta.booktype==\'SIU\'}" onclick="{handleMetaUpdate.bind(this,{name:\'booktype\',value:\'SIU\'})}">Stockport Interpreting Unit (SIU) </label><br> <label> <input type="radio" name="booktype" __checked="{booking.meta.booktype==\'NHS\'}" onclick="{handleMetaUpdate.bind(this,{name:\'booktype\',value:\'NHS\'})}">Stockport NHS Foundation Trust </label> </div> </div> <div show="{booking.meta.booktype==\'NHS\'}" class="form-group"> <label class="control-label col-sm-4">Out of Hours Instructions</label> <div class="col-sm-8"> <p class="form-control-static"><a href="/downloads/out_of_hours_booking_process_for_stockport_nhs.docx">Click here for out of hours booking instructions</a></p> </div> </div> <formselect label="Service Requested" options="{services}" value="{booking.service}" default="Please Choose" name="service" onupdate="{handleUpdate}" isrequired></formselect> <formselect label="Gender Preference" name="gender" options="{genders}" onupdate="{handleUpdate}" value="{booking.gender}" isrequired> </formselect> <formdatetime label="When" name="when" dateformat="dd/MM/yyyy" width1="6" width2="6" value="{booking.when}" onupdate="{handleUpdate}" placeholder="Date" isrequired></formdatetime> <forminput label="Anticipated Duration" name="expected_duration" value="{booking.expected_duration}" onupdate="{handleUpdate}" placeholder="HH:MM" isrequired></forminput> <formtextarea label="Venue Address" name="venue" value="{booking.venue}" onupdate="{handleUpdate}" rows="5" isrequired></formtextarea> <forminput label="Venue Postcode" name="postcode" value="{booking.postcode}" onupdate="{handleUpdate}" isrequired></forminput> <formselect label="Appointment Type" name="type" options="{types}" value="{booking.type}" onupdate="{handleUpdate}" isrequired></formselect> <div class="form-group"> <div class="col-sm-8 col-sm-offset-4"><a href="/terms/interpreter-booking/" target="_blank" class="btn btn-default btn-sm"> View Appointment Type Pricing <span class="fa fa-caret-right"></span></a></div> </div> <formtextarea label="Description of Appointment" name="description" value="{booking.description}" onupdate="{handleUpdate}" isrequired></formtextarea> <div class="form-group"> <div class="col-sm-4 text-right"> <h4>Booked By</h4> </div> </div> <div hide="{loggedin}" class="alert alert-info"> <p>Please make sure you use a valid email address below, as a confirmation email will be sent before the booking is accepted.</p> </div> <forminput label="Forename" name="first_name" value="{booking.user.first_name}" __readonly="{loggedin}" onupdate="{handleUserUpdate}" isrequired></forminput> <forminput label="Surname" name="surname" value="{booking.user.surname}" __readonly="{loggedin}" onupdate="{handleUserUpdate}" isrequired></forminput> <div hide="{loggedin}"> <forminput label="Telephone" name="phone1" value="{booking.user.phone1}" __readonly="{loggedin}" onupdate="{handleUserUpdate}" isrequired></forminput> <forminput label="Fax" name="phone2" value="{booking.user.phone2}" __readonly="{loggedin}" onupdate="{handleUserUpdate}"></forminput> <forminput label="Email" name="email" value="{booking.user.email}" __readonly="{loggedin}" onupdate="{handleUserUpdate}" isrequired type="{\'email\'}"></forminput> </div> <forminput label="Department" name="department" value="{booking.meta.department}" onupdate="{handleMetaUpdate}"></forminput> <forminput label="PO Number" name="po_number" value="{booking.meta.po_number}" onupdate="{handleMetaUpdate}"></forminput> <forminput label="Cost Centre Code" name="cost_center_code" value="{booking.meta.cost_center_code}" onupdate="{handleMetaUpdate}"></forminput> <div class="form-group"> <div class="col-sm-offset-4 col-sm-8"> <div class="checkbox"> <label> <input name="terms" type="checkbox" onchange="{setTerms}">Please tick to indicate you have read and understand <a href="/terms/interpreter-booking/" target="_blank">our terms and conditions</a> </label> </div> </div> </div> <div class="btn-toolbar"> <button type="submit" __disabled="{!terms}" class="pull-right btn btn-primary">Proceed</button> </div><br> <div show="{error}" class="alert alert-danger">{error}</div> <div show="{info &amp;&amp; loggedin}" class="alert alert-success"> <p>Your booking has been requested. Please use the <a href="/system/my-bookings/" class="btn btn-sm btn-success">My Bookings </a> page to monitor it\'s progress.</p> </div> <div show="{info &amp;&amp; !loggedin}" class="alert alert-success"> <h4>Check Your Email</h4> <p> Please check your email, we\'ve sent you a link, once clicked this will log you in and create a new booking.</p> </div> </form>', '.interpreters { background: #eee; padding: 10px 10px 10px 40px; margin }', '', function(opts) {
var xhr;

xhr = require("../libs/xhr.coffee");

this.services = require("../libs/service-list.coffee");

this.genders = [
  {
    label: "No Preference",
    value: "No Preference"
  }, {
    label: "Female",
    value: "female"
  }, {
    label: "Male",
    value: "male"
  }
];

this.interpreters = [];

this.all_interpreters = [];

this.incomplete = true;

this.terms = false;

this.types = [
  {
    label: "Please Select",
    value: null
  }, {
    label: "Medical - Hospital, GPs, Health Visitor, Opticians",
    value: "Medical"
  }, {
    label: "Generic - Meetings, Home Visits (none-medical), Events, Job Interviews",
    value: "Generic"
  }, {
    label: "Specialist - Legal, Mental Health, Child Protection, Police",
    value: "Specialist"
  }
];

this.loggedin = opts.firstname ? true : false;

this.on('mount', function() {
  this.booking = {
    when: null,
    user: {},
    expected_duration: "3:00",
    meta: {
      booktype: ""
    }
  };
  if (window.location.search.match(/editmode=/)) {
    this.root.innerHTML = "<div style='border:2px dashed #a00'>Interpreter Booking Form Component</div>";
  }
  if (opts.firstname) {
    this.booking.user.first_name = opts.firstname;
    this.booking.user.surname = opts.surname;
  }
  return this.update();
});

this.setTerms = (function(_this) {
  return function(e) {
    _this.terms = e.target.checked;
    return _this.update();
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(update) {
    _this.booking[update.name] = update.value;
    return _this.update();
  };
})(this);

this.handleUserUpdate = (function(_this) {
  return function(update) {
    _this.booking.user[update.name] = update.value;
    return _this.update();
  };
})(this);

this.handleMetaUpdate = (function(_this) {
  return function(update) {
    _this.booking.meta[update.name] = update.value;
    return _this.update();
  };
})(this);

this.save = (function(_this) {
  return function(e) {
    e.preventDefault();
    if (!_this.booking.when || _this.booking.when < new Date) {
      _this.update({
        error: "Please provide a valid booking date and time"
      });
      setTimeout((function() {
        return _this.update({
          error: null
        });
      }), 5000);
      return;
    }
    _this.update({
      info: null,
      error: null
    });
    if (_this.loggedin) {
      xhr("post", "/duocms/api/appointments", _this.booking, function(res) {
        return _this.handleResponse(res);
      });
    } else {
      xhr("post", "/duocms/api/appointments/apply", _this.booking, function(res) {
        return _this.handleResponse(res);
      });
    }
    return console.log("saving...");
  };
})(this);

this.handleResponse = (function(_this) {
  return function(arg) {
    var body, status;
    status = arg.status, body = arg.body;
    if (status === 200) {
      _this.booking = {
        when: null,
        user: {},
        duration: "3:00",
        meta: {}
      };
      _this.info = true;
      _this.update({
        info: body.data
      });
    } else {
      _this.update({
        error: body.message
      });
    }
    return console.log({
      status: status,
      body: body
    });
  };
})(this);
});
    
  